export const GET_CONCESSION = 'sagas/concession/GET_CONCESSION'
export const FILL_CONCESSION = 'sagas/concession/FILL_CONCESSION'
export const CREATE_CONCESSION = 'sagas/concession/CREATE_CONCESSION'
